import axios from 'axios';

const runSimulation = async (car, time, distance, downpayment) => {
    try {
        const response = await axios.post('/api/kinto/service_simulation/', {
            car,
            time: time.value,
            distance: distance.value,
            downpayment: downpayment
        }, {
            headers: {
                'X-CSRFToken': document.querySelector('meta[name ="csrf-token"]').content
            }
        });
        const simulation = response.data;
        return { success: true, data: simulation };
    } catch (error) {        
        // Determinar el tipo de error
        let errorMessage = 'Error al simular. Por favor, intenta con otra combinación.';
        
        if (error.response) {
            // El servidor respondió con un código de error
            if (error.response.status === 404) {
                errorMessage = 'Esta combinación de tiempo y kilometraje no está disponible.';
            } else if (error.response.status === 400) {
                errorMessage = error.response.data?.message || 'Inténtalo nuevamente.';
            } else if (error.response.status >= 500) {
                errorMessage = 'Error del servidor. Por favor, intenta más tarde.';
            }
        } else if (error.request) {
            // La petición se hizo pero no hubo respuesta
            errorMessage = 'No se pudo conectar con el servidor. Verifica tu conexión.';
        }
        
        return { 
            success: false, 
            error: errorMessage,
            data: null 
        };
    }
}

const getTotalFromSimulation = simulation => {
    if (!simulation || !simulation.amortization || !simulation.amortization[1]) {
        return 0;
    }
    return simulation.amortization[1].totalQuota;
}

export { runSimulation, getTotalFromSimulation };